import 'css-chunksrc/client/common/projectsSelection/scrollPane/styles.scss';export default {
  "scrollPane": "_scrollPane_3g07h_1"
};